<script>
import CalendarPostsCard from './CalendarPostsCard.vue';

export default {
    name: 'CalendarPosts',
    inject: ['$t'],
    components: {
        CalendarPostsCard
    },
    props: {
        date: {
            type: Date,
            required: true
        },
        posts: {
            type: Array,
            required: true
        }
    },
    methods: {
        setPreviousDay() {
            const date = new Date(this.date);
            date.setDate(date.getDate() - 1);
            this.$emit('set-previous-day', date);
        },
        setToday() {
            this.$emit('set-previous-day', new Date());
        }
    }
};
</script>

<template>
    <div class="w-full px-[57px]">
        <template v-if="posts.length !== 0">
            <slot name="posts" :posts="posts">
                <div class="gap-8.5 mb-8 grid grid-cols-3">
                    <CalendarPostsCard
                        v-for="(post, index) in posts"
                        :key="index"
                        :post="post"
                    />
                </div>
            </slot>
        </template>
        <div class="flex h-6 w-full items-center justify-center">
            <a
                @click.prevent="setPreviousDay"
                class="mr-4 flex cursor-pointer items-center"
            >
                <i class="sw-icons-sm-arrow-left"></i>
            </a>
            <a
                @click.prevent="setToday"
                class="mr-4 flex cursor-pointer items-center"
            >
                {{ $t('Today') }}
            </a>
        </div>
    </div>
</template>
